<template>
    <!--专家团队-->
    <div class="expert">
        <div class="expert_box">
            <div class="team_box" v-for="(item) in list" :key="item.id">
                <div class="team_item">
                    <div class="team_top">
                        <div class="team_left">
                            <img class="team_img" :src="item.thumb" alt="">
                        </div>
                        <div class="team_right">
                            <div class="name">
                                {{ item.name }}
                            </div>
                            <div class="info">
                                职业：{{ item.job }}
                            </div>
                            <div class="info">
                                领域：{{ item.position }}
                            </div>
                        </div>
                    </div>
                    <div class="team_bottom">
                        专家介绍： {{ item.explain }}
                    </div>
                </div>
            </div>
            <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :current-page.sync="page"
                    :page-size="limit"
                    layout="total, prev, pager, next"
                    :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
	import {person} from "../../apiNew/index";

	export default {
		name: 'expert',
		data() {
			return {
				list: [],
				page: 1,
				limit: 10,
				total: 0,
			}
		},
		components: {},
		mounted() {
			this.init()
		},
		methods: {
			init() {
				person({
					page: this.page,
					limit: this.limit,
				}).then(res => {
					// console.log(res)
					this.list = res.data.data
					this.total = res.data.total
					// if (res.data.total === 0) {
					// 	document.querySelector(".have_more").innerHTML = "暂无数据";
					// } else if (res.data.total < this.limit) {
					// 	document.querySelector(".have_more").innerHTML = "已加载完毕";
					// }
				}).catch(error => {
					console.log(error)
				})
			},
			handleCurrentChange(val) {
				this.page = val
				this.init()
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
			},
		}
	}
</script>

<style lang="less" rel="stylesheet/less" scoped>
    @import "expert";
</style>
